import { render, staticRenderFns } from "./myDingzhi.vue?vue&type=template&id=05f76e87&scoped=true&"
import script from "./myDingzhi.vue?vue&type=script&lang=js&"
export * from "./myDingzhi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f76e87",
  null
  
)

export default component.exports